import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { getMessage } from '@/helpers/utils';
import i18n from '@/i18n';
import { userService } from '../../services/userService';

const { t } = i18n;

export const useResetPassword = () => {
  return useMutation({
    mutationFn: payload =>
      userService.resetPassword(payload).then(response => {
        const { data } = response;
        Notify.success({ text: getMessage(data, t('auth:recover_password.success')) });
        return data;
      }),
    onError: error => {
      const status = error?.response?.status;

      if (status >= 400 && status < 500) {
        Notify.error({
          text: getMessage(error?.response?.data, t('auth:recover_password.error')),
        });
      }
    },
  });
};
